import { UserAssignmentStatusCodeType } from '@/const/shared';
import { authApiService } from '../../authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

type AssignmentStatusType = {
  is_available_to_assign: true;
  code: UserAssignmentStatusCodeType;
};

export const getExecutorAssignmentStatusApi = async (
  userId: string
): Promise<ApiResponseType<AssignmentStatusType>> => {
  const uri = `/organization/executors/users/${userId}/assignment-status/`;

  return authApiService.GET(uri);
};
